import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { BASEURL } from "../../../constants";

const correctSound = new  Audio("/sounds/correct.wav"); // Path to correct sound
const incorrectSound = new  Audio("/sounds/incorrect.wav"); // Path to incorrect sound

const PreviewImageRecognition = ({ data }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isCorrect, setIsCorrect] = useState(null);
  const [state, setState] = useState({
    image: "", // Store image URL
    imageKey: "",
    options: ["", "", "", ""],
    correctAnswer: null,
  });

  const handleOptionClick = (index) => {
    setSelectedOption(index);
    const isAnswerCorrect = index === data.correctAnswer;
    setIsCorrect(isAnswerCorrect);

    // Play sound
    if (isAnswerCorrect) {
      correctSound.play();
    } else {
      incorrectSound.play();
    }
  };

  useEffect(() => {
    if (data) {
      setState(data);
      fetchImage(data);
    }
  }, []);

  const fetchImage = async (data) => {
    try {
      const uniqueId = uuidv4();
      const imageResponseObject = await axios.get(`${BASEURL}/api/get-image`, {
        params: { imageId: data.imageKey },
      });

      setState((prev) => ({
        ...prev,
        image: imageResponseObject.data?.dataUrl || "",
        imageKey: uniqueId,
      }));
    } catch (error) {
      console.error("Error fetching image:", error);
    }
  };

  return (
    <div className="p-6 bg-white shadow-md rounded-lg w-full max-w-4xl mx-auto mt-10">
      <h1 className="text-3xl text-center mb-10 font-semibold">What is my name?</h1>

      {/* Question Image */}
      {state.image && (
        <div className="flex justify-center mb-6">
          <img
            src={state.image}
            alt="Question"
            className="w-64 h-64 object-contain rounded-lg shadow-md"
          />
        </div>
      )}

      {/* Instruction */}
      <p className="text-gray-500 font-medium text-center mb-4">
        Select the correct option by looking at the image.
      </p>

      {/* Options */}
      <div className="grid grid-cols-2 gap-4 justify-center">
        {state.options.map(
          (option, index) =>
            option && ( // Only render if the option is not an empty string
              <button
                key={index}
                onClick={() => handleOptionClick(index)}
                className={`py-3 px-6 border-2 rounded-lg text-lg font-semibold transition-all duration-300 ${
                  selectedOption === index
                    ? isCorrect
                      ? "border-green-500 bg-green-100 text-green-800"
                      : "border-red-500 bg-red-100 text-red-800"
                    : "border-gray-300 bg-white hover:bg-gray-100"
                }`}
              >
                {option}
              </button>
            )
        )}
      </div>

      {/* Feedback Message */}
      {isCorrect !== null && (
        <div
          className={`mt-6 py-3 px-4 rounded-lg text-center font-bold ${
            isCorrect ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
          }`}
        >
          {isCorrect ? "✅ Correct! Well done!" : "❌ Incorrect. Try again!"}
        </div>
      )}
    </div>
  );
};

export default PreviewImageRecognition;

